define.alias("shared/components/shared/post-tagging/select/tag-select-item", "media/components/shared/post-tagging/select/tag-select-item");